export const colors = {
  primary: {
    focus: "#E5E9F9",
    50: "#EAEDFA",
    100: "#BDC7F0",
    200: "#9DABE8",
    300: "#7085DE",
    400: "#546DD8",
    500: "#2949CE",
    600: "#2542BB",
    700: "#1D3492",
    800: "#172871",
    900: "#111F57",
  },
  softLavender: {
    50: "#FBFAFF",
    100: "#F3EFFE",
    200: "#EDE8FD",
    300: "#E4DDFC",
    400: "#DFD6FC",
    500: "#D7CCFB",
    600: "#C4BAE4",
    700: "#9991B2",
    800: "#7670BA",
    900: "#5A5669",
  },
  darkCharcoal: {
    50: "#F7F9FA",
    100: "#F5F6F7",
    200: "#EBEFF2",
    300: "#DFE2E5",
    400: "#CDD1D4",
    500: "#ACB2B7",
    600: "#828B92",
    700: "#59656E",
    800: "#2F3E4A",
    900: "#061826",
  },
  gray: {
    50: "#F5F5F5",
    100: "#EEEEEE",
    200: "#E0E0E0",
    300: "#E0E0E0",
    400: "#BDBDBD",
    500: "#9E9E9E",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#F5F5F5",
    A200: "#EEEEEE",
    A400: "#BDBDBD",
    A700: "#616161",
  },
  coolGrey: {
    50: "#F7F9FF",
    100: "#EDF0F7",
    200: "#E1E4EE",
    300: "#CDD2E2",
    400: "#B4BBD4",
    500: "#9BA5C6",
    600: "#828EB7",
    700: "#456070",
    800: "#363E57",
    900: "#262B3D",
  },
  success: {
    50: "#EAFAEF",
    100: "#BDF0CC",
    200: "#9DE8B4",
    300: "#70DE92",
    400: "#54D87D",
    500: "#29CE5C",
    600: "#25BB54",
    700: "#1D9241",
    800: "#177133",
    900: "#115727",
  },
  error: {
    50: "#FAEAF5",
    100: "#F0BDE0",
    200: "#E89DD1",
    300: "#DE70BC",
    400: "#D854AF",
    500: "#CE299B",
    600: "#BB258D",
    700: "#921D6E",
    800: "#711755",
    900: "#571141",
  },
  warning: {
    50: "#FAF7EA",
    100: "#F0E6BD",
    200: "#E8DA9D",
    300: "#DEC970",
    400: "#D8BE54",
    500: "#CEAE29",
    600: "#BB9E25",
    700: "#927C1D",
    800: "#716017",
    900: "#574911",
  },
  information: {
    50: "#EAF5FA",
    100: "#BDE0F0",
    200: "#9DD1E8",
    300: "#70BCDE",
    400: "#54AFD8",
    500: "#299BCE",
    600: "#258DBB",
    700: "#1D6E92",
    800: "#175571",
    900: "#114157",
  },
  action: {
    hover: "#F5F5F5",
  },
  blackAlpha: {
    10: "rgba(0,0,0,0.10)",
    20: "rgba(0,0,0,0.20)",
    23: "rgba(0,0,0,0.23)",
    30: "rgba(0,0,0,0.30)",
    40: "rgba(0,0,0,0.40)",
    50: "rgba(0,0,0,0.50)",
    60: "rgba(0,0,0,0.60)",
    70: "rgba(0,0,0,0.70)",
    80: "rgba(0,0,0,0.80)",
    90: "rgba(0,0,0,0.90)",
    100: "#000000",
  },
  white: "#FFFFFF",
  amber: {
    50: "#FFF8E1",
    100: "#FFECB3",
    200: "#FFE082",
    300: "#FFD54F",
    400: "#FFCA28",
    500: "#FFC107",
    600: "#FFB300",
    700: "#FFA000",
    800: "#FF8F00",
    900: "#FF6F00",
    A100: "#FFE57F",
    A200: "#FFD740",
    A400: "#FFC400",
    A700: "#FFAB00",
  },
  blueGrey: {
    50: "#ECEFF1",
    100: "#CFD8DC",
    200: "#B0BEC5",
    300: "#90A4AE",
    400: "#78909C",
    500: "#607D8B",
    600: "#607D8B",
    700: "#455A64",
    800: "#37474F",
    900: "#263238",
    A100: "#CFD8DC",
    A200: "#CFD8DC",
    A400: "#78909C",
    A700: "#455A64",
  },
  cyan: {
    50: "#E0F7FA",
    100: "#B2EBF2",
    200: "#80DEEA",
    300: "#4DD0E1",
    400: "#26C6DA",
    500: "#00BCD4",
    600: "#00ACC1",
    700: "#0097A7",
    800: "#00838F",
    900: "#006064",
    A100: "#84FFFF",
    A200: "#18FFFF",
    A400: "#00E5FF",
    A700: "#00E5FF",
  },
  deepOrange: {
    50: "#FBE9E7",
    100: "#FFCCBC",
    200: "#FFAB91",
    300: "#FFAB91",
    400: "#FF7043",
    500: "#FF5722",
    600: "#F4511E",
    700: "#E64A19",
    800: "#D84315",
    900: "#BF360C",
    A100: "#FF9E80",
    A200: "#FF6E40",
    A400: "#FF3D00",
    A700: "#DD2C00",
  },
  deepPurple: {
    50: "#EDE7F6",
    100: "#D1C4E9",
    200: "#B39DDB",
    300: "#9575CD",
    400: "#7E57C2",
    500: "#673AB7",
    600: "#5E35B1",
    700: "#5E35B1",
    800: "#4527A0",
    900: "#311B92",
    A100: "#B388FF",
    A200: "#7C4DFF",
    A400: "#651FFF",
    A700: "#6200EA",
  },
  indigo: {
    50: "#E8EAF6",
    100: "#C5CAE9",
    200: "#9FA8DA",
    300: "#7986CB",
    400: "#5C6BC0",
    500: "#3F51B5",
    600: "#3949AB",
    700: "#303F9F",
    800: "#283593",
    900: "#1A237E",
    A100: "#8C9EFF",
    A200: "#536DFE",
    A400: "#3D5AFE",
    A700: "#304FFE",
  },
  lightBlue: {
    50: "#E1F5FE",
    100: "#B3E5FC",
    200: "#B3E5FC",
    300: "#4FC3F7",
    400: "#29B6F6",
    500: "#03A9F4",
    600: "#039BE5",
    700: "#0288D1",
    800: "#0277BD",
    900: "#01579B",
    A100: "#80D8FF",
    A200: "#40C4FF",
    A400: "#00B0FF",
    A700: "#0091EA",
  },
  lightGreen: {
    50: "#F1F8E9",
    100: "#DCEDC8",
    200: "#C5E1A5",
    300: "#AED581",
    400: "#8BC34A",
    500: "#8BC34A",
    600: "#7CB342",
    700: "#689F38",
    800: "#558B2F",
    900: "#33691E",
    A100: "#CCFF90",
    A200: "#B2FF59",
    A400: "#76FF03",
    A700: "#64DD17",
  },
  lime: {
    50: "#F9FBE7",
    100: "#F0F4C3",
    200: "#E6EE9C",
    300: "#DCE775",
    400: "#D4E157",
    500: "#CDDC39",
    600: "#C0CA33",
    700: "#AFB42B",
    800: "#9E9D24",
    900: "#827717",
    A100: "#827717",
  },
  orange: {
    50: "#FFF3E0",
    100: "#FFE0B2",
    200: "#FFCC80",
    300: "#FFB74D",
    400: "#FFA726",
    500: "#FF9800",
    600: "#FB8C00",
    700: "#F57C00",
    800: "#EF6C00",
    900: "#E65100",
    A100: "#E65100",
    A200: "#E65100",
    A400: "#E65100",
    A700: "#E65100",
  },
  pink: {
    50: "#FCE4EC",
    100: "#F8BBD0",
    200: "#F48FB1",
    300: "#F06292",
    400: "#EC407A",
    500: "#E91E63",
    600: "#D81B60",
    700: "#C2185B",
    800: "#AD1457",
    900: "#880E4F",
    A100: "#FF80AB",
    A200: "#FF4081",
    A400: "#F50057",
    A700: "#C51162",
  },
  purple: {
    50: "#C51162",
    100: "#E1BEE7",
    200: "#CE93D8",
    300: "#BA68C8",
    400: "#AB47BC",
    500: "#9C27B0",
    600: "#8E24AA",
    700: "#7B1FA2",
    800: "#6A1B9A",
    900: "#4A148C",
    A100: "#EA80FC",
    A200: "#E040FB",
    A400: "#D500F9",
    A700: "#AA00FF",
  },
  teal: {
    50: "#E0F2F1",
    100: "#B2DFDB",
    200: "#80CBC4",
    300: "#4DB6AC",
    400: "#26A69A",
    500: "#009688",
    600: "#00897B",
    700: "#00796B",
    800: "#00695C",
    900: "#004D40",
    A100: "#A7FFEB",
    A200: "#64FFDA",
    A400: "#1DE9B6",
    A700: "#00BFA5",
  },
  yellow: {
    50: "#FFFDE7",
    100: "#FFF9C4",
    200: "#FFF9C4",
    300: "#FFF176",
    400: "#FFEE58",
    500: "#FFEB3B",
    600: "#FDD835",
    700: "#FBC02D",
    800: "#F9A825",
    900: "#F57F17",
    A100: "#FFFF8D",
    A200: "#FFFF00",
    A400: "#FFEA00",
    A700: "#FFD600",
  },
} as const;
